import styled, {css} from "styled-components";

type PagerProps = {
  reverse?: boolean;
};

type ContentProps = {
  alignEnd?: boolean;
};

type DynamicLabelProps = {
  alignRight?: boolean;
};

type IconProps = {
  right?: boolean;
  left?: boolean;
};

export const NavigationContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 50px;
`;

export const Pager = styled.div<PagerProps>`
  background: white;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border-radius: 8px;
  padding: 15px 20px;
  width: 100%;

  ${({ reverse }) =>
      reverse &&
      css`
        flex-direction: row-reverse;
      `}
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;

  ${({ alignEnd }) =>
      alignEnd &&
      css`
        align-items: flex-end;
      `}
`;

export const Label = styled.div`
  color: gray;
  line-height: 16px;
`;

export const DynamicLabel = styled.div<DynamicLabelProps>`
  color: #333;
  font-size: 16px;
  font-weight: 500;

  ${({ alignRight }) =>
      alignRight &&
      css`
        text-align: right;
      `}
`;

export const IconWrapper = styled.div`
  font-size: 12px;
  display: grid;
  place-items: center;
`;

export const Icon = styled.span<IconProps>`
  color: #333;
  font-size: 200%;
  margin-left: ${({ left }) => (left ? "10px" : "0")};
  margin-right: ${({ right }) => (right ? "10px" : "0")};
`;
